// extracted by mini-css-extract-plugin
module.exports = {"container":"MoreFeatures_container__3_i5A","text":"MoreFeatures_text__3Znll","icon":"MoreFeatures_icon__3EkGs","label":"MoreFeatures_label__2-ztt"};